import gql from 'graphql-tag';

export const GET_LENDER_TERM_DISTRIBUTION_BY_LENDER = gql`
  query LenderTermDistributionByLender($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      result: termDistributionByLender(input: $input) {
        success
        error
        entity {
          lenderProfileId
          lenderName
          buckets {
            term
            percentage
          }
        }
      }
    }
  }
`;
